export default "__VITE_ASSET__GvxsQ5gw__"